module.exports = __webpack_public_path__ + "static/img/anos_80.27c3e70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/linha-tempo/anos_80.png
// module id = ow7c
// module chunks = 0